/* eslint-disable no-console */
import { httpModule } from '@shared/http';

export type User = {
    id: number,
    username: string,
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    roles: [
        {
            id: number,
            role: string
        }
    ],
    organization: number
};

export async function fetchUsers(page?: number, limit?: number) {
    try {
        return await httpModule.get('/users', {
            params: { page, limit }
        });
    } catch (ex) {
        console.warn(`Error fetching users`);
        console.log(ex);
    }
}